import { Injectable } from '@angular/core';
import { of, forkJoin, BehaviorSubject, Subject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { siteDetails } from 'src/assets/urlwiseconfig';
import * as jsonData from '../../assets/js/siteDetails.json';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private token = null;
  public socketConnection : any;
  isAdminLoginForOtherUser = new Subject<boolean>();
  public commonModel = new Subject<boolean>();
  public commonModelReset = new Subject<any>();
  public pageLoadInModal = new Subject<string>();
  public headerPopupEvent = new Subject<any>();
  private map: google.maps.Map | undefined;
  audio:any;
  router:Router;
  private BASE_URL = environment.apiUrl;
  //private BASE_RoasterUrl = environment.roasterUrl;
  addressBylatLong:any = {};
  private httpOptions = {};
  Language = new BehaviorSubject<string>('en');
  private apiUrl = 'https://ccbackend.tikona.in/v2/clickToCall/para';

  // private  apiKey = 'AIzaSyCDKNXzPKhm8UWNV_o8MOXSAiZCpc4Hwrg';
  constructor(private http: HttpClient, private cookieService: CookieService) {
    this.httpOptions = {
};
  }
  closeSocket() {
    if(this.socketConnection){
      this.socketConnection.close();
    }
  }
  getSiteDetails() {
    let siteDomain = window.location.host;
    let data: any = (jsonData as any).default;
    let filterSiteDetails =  data.find(site=>siteDomain.indexOf(site.name) >= 0);
    return filterSiteDetails && filterSiteDetails.details ? filterSiteDetails.details : { logo:'',text:'Not Found',name:'NA'} 
  }
  getRequest(apiUrl: string, parameter: Array<string>,withoutContentType=false,withoutAuth=false) {
    return new Promise(async (resolve) => {
      const basicToken = localStorage.getItem('basicToken');
      if(withoutContentType){
        this.httpOptions = {
        };
      } else {
        this.httpOptions = {
          'Content-Type': 'application/json; charset=utf8',
        };
      }
      if (!withoutAuth && basicToken) {
        this.httpOptions['Authorization'] = 'Basic ' + basicToken;
      }
      this.httpOptions['Accept']='application/json';

      let extraParam = '';
      if (parameter?.length) {
        extraParam = '?' + parameter.join('&');
      }
      const response = await fetch(this.BASE_URL + apiUrl + extraParam, {
        method: 'GET',
        credentials: 'include',
        headers: this.httpOptions,
      });
      if (response.ok) {
        try {
          const responseJson = await response.json();
          resolve({
            status: true,
            data: responseJson,
          });
        } catch (error) {
          
        resolve({
          status: false,
          data: '',
        });
        }
      } else {
        const responseJson = await response;
        resolve({
          status: false,
          data: responseJson,
        });
      }
    });
  }
  getRequestWithToken(apiUrl: string, parameter: Array<string>,withoutContentType=false,withoutAuth=false) {
    return new Promise(async (resolve) => {
      const basicToken = localStorage.getItem('socketBasicToken');
      if(withoutContentType){
        this.httpOptions = {
        };
      } else {
        this.httpOptions = {
          'Content-Type': 'application/json; charset=utf8',
        };
      }
      if (!withoutAuth && basicToken) {
        this.httpOptions['Authorization'] = 'Basic ' + basicToken;
      }
      this.httpOptions['Accept']='application/json';

      let extraParam = '';
      if (parameter?.length) {
        extraParam = '?' + parameter.join('&');
      }
      const response = await fetch(this.BASE_URL + apiUrl + extraParam, {
        method: 'GET',
        credentials: 'include',
        headers: this.httpOptions,
      });
      if (response.ok) {
        try {
          const responseJson = await response.json();
          resolve({
            status: true,
            data: responseJson,
          });
        } catch (error) {
          
        resolve({
          status: false,
          data: '',
        });
        }
      } else {
        const responseJson = await response;
        resolve({
          status: false,
          data: responseJson,
        });
      }
    });
  }
  getTasks(url1:any,assignedTo: string, supervisorId: string, fromDate: string, toDate: string, clientId: string,status:string): Observable<any> {
  const basicToken = localStorage.getItem('basicToken');
  assignedTo = assignedTo != null ? assignedTo.toString().trim() : '';
  supervisorId = supervisorId != null ? supervisorId.toString().trim() : '';
  clientId = clientId != null ? clientId.toString().trim() : '';
  if (basicToken) {
    this.httpOptions['Authorization'] = 'Basic ' + basicToken;
  }
    let url = `${this.BASE_URL}${url1}?`;
    if (assignedTo !== '') {
      url += `assignedto=${assignedTo}&`;
    }
  
    if (supervisorId !== '') {
      url += `supervisorid=${supervisorId}&`;
    }
  
  
    if (fromDate !== '') {
      url += `fromdate=${fromDate}&`;
    }
    
    if (toDate !== '') {
      url += `todate=${toDate}&`;
    }

    if (clientId !== '') {
      url += `clientid=${clientId}&`;
    }

    if(status !== '')
    {
      url+=`status=${status}`
    }
    return this.http.get(url, { headers: this.httpOptions });
  }

   getClientTasks(url1:any): Observable<any> {
     let url=`${this.BASE_URL}${url1}`;
  const basicToken = localStorage.getItem('basicToken');
 
  if (basicToken) {
    this.httpOptions['Authorization'] = 'Basic ' + basicToken;
  }
   
    return this.http.get(url, { headers: this.httpOptions });
  }

    getDistanceMatrix(origins: string, destinations: string, mode: string): Observable<any> {
      const apiUrl = `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${origins}&destinations=${destinations}&mode=${mode}&key=$AIzaSyCDKNXzPKhm8UWNV_o8MOXSAiZCpc4Hwrg`;
      return this.http.get(apiUrl);
    }

  // getRequestRoaster(apiUrl: string, parameter: Array<string>,withoutContentType=false,withoutAuth=false) {
  //   return new Promise(async (resolve) => {
  //     const basicToken = localStorage.getItem('basicToken');
  //     if(withoutContentType){
  //       this.httpOptions = {
          
  //       };
  //     } else {
  //       this.httpOptions = {
  //         'Content-Type': 'application/json; charset=utf8',
  //       };
  //     }
  //     if (!withoutAuth && basicToken) {
  //       this.httpOptions['Authorization'] = 'Basic ' + btoa('rostersuperviosr:123456');
  //     }
  //     this.httpOptions['Accept']='application/json';

  //     let extraParam = '';
  //     if (parameter?.length) {
  //       extraParam = '?' + parameter.join('&');
  //     }
  //     const response = await fetch(this.BASE_RoasterUrl + apiUrl + extraParam, {
  //       method: 'GET',
  //       credentials: 'include',
  //       headers: this.httpOptions,
  //     });
  //     if (response.ok) {
  //       try {
  //         const responseJson = await response.json();
  //         resolve({
  //           status: true,
  //           data: responseJson,
  //         });
  //       } catch (error) {
          
  //       resolve({
  //         status: false,
  //         data: '',
  //       });
  //       }
  //     } else {
  //       const responseJson = await response;
  //       resolve({
  //         status: false,
  //         data: responseJson,
  //       });
  //     }
  //   });
  // }
  postRequest(apiUrl: string, body: any) {
    return new Promise(async (resolve,reject) => {
      this.httpOptions = {
        'Content-Type': 'application/json; charset=utf8',
      };
      const basicToken = localStorage.getItem('basicToken');
      if (basicToken) {
        this.httpOptions['Authorization'] = 'Basic ' + basicToken;
      }

      const response = await fetch(this.BASE_URL + apiUrl, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify(body),
        headers: this.httpOptions,
      });
      if (response.ok) {
        if(response.status == 204) {
          resolve({
            status: true,
            data: '',
          });
        } else {
          const responseJson = await response.json();
          resolve({
            status: true,
            data: responseJson,
          });
        }
        
      } else {
        const responseJson = await response;
        reject({
          status: false,
          data: responseJson,
        });
      }
    });
  }
  postRequestWithToken(apiUrl: string, body: any) {
    return new Promise(async (resolve,reject) => {
      this.httpOptions = {
        'Content-Type': 'application/json; charset=utf8',
      };
      const basicToken = localStorage.getItem('socketBasicToken');
      if (basicToken) {
        this.httpOptions['Authorization'] = 'Basic ' + basicToken;
      }

      const response = await fetch(this.BASE_URL + apiUrl, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify(body),
        headers: this.httpOptions,
      });
      if (response.ok) {
        if(response.status == 204) {
          resolve({
            status: true,
            data: '',
          });
        } else {
          const responseJson = await response.json();
          resolve({
            status: true,
            data: responseJson,
          });
        }
        
      } else {
        const responseJson = await response;
        reject({
          status: false,
          data: responseJson,
        });
      }
    });
  }


  postRequestForFile(apiUrl: string, body: FormData) {
    return new Promise(async (resolve,reject) => {
      this.httpOptions = {};
      const basicToken = localStorage.getItem('basicToken');
      if (basicToken) {
        this.httpOptions['Authorization'] = 'Basic ' + basicToken;
      }

      const response = await fetch(this.BASE_URL + apiUrl, {
        method: 'POST',
        credentials: 'include',
        body: body,
        headers: this.httpOptions,
      });
      if (response.ok) {
        if(response.status == 204) {
          resolve({
            status: true,
            data: '',
          });
        } else {
          const responseJson = await response.json();
          resolve({
            status: true,
            data: responseJson,
          });
        }
        
      } else {
        const responseJson = await response;
        reject({
          status: false,
          data: responseJson,
        });
      }
    });
  }
  putRequest(apiUrl: string, body: any) {
    this.httpOptions = {
      'Content-Type': 'application/json; charset=utf8',
    };
    return new Promise(async (resolve,reject) => {
      const basicToken = localStorage.getItem('basicToken');
      const socketBasicToken = localStorage.getItem('socketBasicToken');
      if (basicToken) {
        this.httpOptions['Authorization'] = 'Basic ' + basicToken;
      }
      else if(socketBasicToken){
        this.httpOptions['Authorization'] = 'Basic ' + socketBasicToken;
      }

      const response = await fetch(this.BASE_URL + apiUrl, {
        method: 'PUT',
        credentials: 'include',
        body: JSON.stringify(body),
        headers: this.httpOptions,
      });
      if (response.ok) {
        const responseJson = await response.json();
        resolve({
          status: true,
          data: responseJson,
        });
      } else {
        reject({
          status: false,
          data: await response.json(),
        });
      }
    });
  }
  otherUserLogin(userId,adminId=0) {
    this.getRequest('session/'+ userId,null,true).then((resp: any) => {
      this.getRequest('server',null,true).then((resp: any) => {
        this.getRequest('session',null,true,true).then((resp: any) => {
          if (resp?.status) {
            this.setAdminOtherLogin(resp.data,adminId)
            
          }
        });
      });
    });
  }
  setAdminOtherLogin(responseData,adminId){
    
    localStorage.setItem('temp_adm_user_id',adminId);
    localStorage.setItem('Admin_User_Id',  localStorage.getItem('userData'));
    localStorage.setItem('Admin_token', localStorage.getItem('token'));

    localStorage.setItem('userData', JSON.stringify(responseData));
    localStorage.setItem('token', responseData.token);
    this.isAdminLoginForOtherUser.next(adminId ? true:false);
  }
  backToAdminSession(adminId){
    localStorage.removeItem('temp_adm_user_id');
  }
  deleteRequest(apiUrl: string, body: any = null) {
    this.httpOptions = {
      'Content-Type': 'application/json; charset=utf8',
    };
    return new Promise(async (resolve) => {
      const basicToken = localStorage.getItem('basicToken');
      if (basicToken) {
        this.httpOptions['Authorization'] = 'Basic ' + basicToken;
      }
      try {


        
        let dataSet = {
          method: 'DELETE',
          credentials: 'include',
          headers: this.httpOptions,
        };

        if (body) {
          dataSet['body'] = JSON.stringify(body);
        }
        const response = await fetch(this.BASE_URL + apiUrl, {
          method: 'DELETE',
          credentials: 'include',
          headers: this.httpOptions,
          body : (body? JSON.stringify(body):'')
        });
        if (response.ok) {
          const responseJson = await response.json();
          resolve({
            status: true,
            data: responseJson,
          });
        } else {
          resolve({
            status: false,
            data: response,
          });
        }
      } catch (error) {
        resolve({
          status: false,
          data: null,
        });
      }
    });
  }
  deleteResource(url: string): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Accept-Language': 'en-US,en;q=0.9,fr;q=0.8',
      'Content-Type': 'application/json; charset=utf8',
      // Add other headers as needed
    });

    return this.http.delete<any>(this.BASE_URL+url, { headers });
  }

  postRequestSesstion(apiUrl,body) {
    let _url = this.BASE_URL + apiUrl;
    
  let options = {
    headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    withCredentials: true
  };
      return this.http.post<any>(_url,body,options);
  }
  

  postFormRequest(apiUrl: string, body: any,isAuth = false) {
    return new Promise(async (resolve) => {
      const basicToken = localStorage.getItem('basicToken');
      
      let header = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf8',
      }
      if (basicToken && isAuth) {
        header['Authorization'] = 'Basic ' + basicToken;
      }
      const response = await fetch(this.BASE_URL + apiUrl, {
        method: 'POST',
        credentials: 'include',
        body: body,
        headers: header,
      });
      if (response.ok) {
        const responseJson = await response.json();
        resolve({
          status: true,
          data: responseJson,
        });
      } else {
        resolve({
          status: false,
          data: response,
        });
      }
    });
  }

  getUserDetails() {
    let userDetails = {};
    let user = localStorage.getItem('userData');
    if (user) {
      userDetails = JSON.parse(user);
    }
    return of(userDetails);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any) => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  getDeviceAddress(latitude,longitude,deviceId = '') {
    if(!(latitude && longitude&& this.addressBylatLong[latitude+'_'+longitude])){
      let params = [
        'latitude=' + longitude,
        'longitude=' + latitude,
        'maxDistance=1000'
      ];
      if (latitude && longitude) {
        this
        .getRequest('statistics/getAddress?' + params.join('&'), [])
        .then((resp: any) => {
          if(resp.data && resp.data.address){
            if(deviceId) {
              this.addressBylatLong[deviceId] = resp.data.address;
          
            }
            this.addressBylatLong[latitude+'_'+longitude] = resp.data.address;
          }
        }).finally(()=>{
         
        });
    }
    }
    

    
  }
  playAudio(notifSignal){
    if(notifSignal == 3){
      this.audio = new Audio();
      this.audio.src = 'assets/audio/notification.mp3';
      this.audio.play();
      Audio.prototype.stop = function()
      {
          this.pause();
          this.currentTime = 0.0;
      }
    }else{
      this.audio = new Audio();
      this.audio.src = 'assets/audio/notification.mp3';
      this.audio.play();
    }
  }
  // getWorldTimeZoneList() {
  //   return this.http.get("http://worldtimeapi.org/api/timezone", {headers: this.httpOptions});
  // }

  // calltoDriver(body: any) {
  //   return new Promise(async (resolve,reject) => {
  //    this.httpOptions = {
  //       'Content-Type': 'application/json',
  //       'cache-control': 'no-cache'
  //     };

  //     const response = await fetch('https://ccbackend.tikona.in/v2/clickToCall/para', {
  //       method: 'POST',
  //       headers: this.httpOptions,
  //       body: null,
  //       params: {
  //         user_id : '75694186',
  //         token: '6TDHMWLh6XbU5kC3THsh',
  //         from: 'FROM_NUMBER',
  //         to: 'TO_NUMBER'
  //       }
  
  //     });
  //     if (response.ok) {
  //       if(response.status == 204) {
  //         resolve({
  //           status: true,
  //           data: '',
  //         });
  //       } else {
  //         const responseJson = await response.json();
  //         resolve({
  //           status: true,
  //           data: responseJson,
  //         });
  //       }
        
  //     } else {
  //       const responseJson = await response;
  //       reject({
  //         status: false,
  //         data: responseJson,
  //       });
  //     }
  //   });
  // }


  makePostRequest(user_id: string, token: string, from: string, to: string): Observable<any> {
    const options = {
      headers: {
        'cache-control': 'no-cache'
      }
    };

    const queryParams = `?user_id=${user_id}&token=${token}&from=${from}&to=${to}`;

    return this.http.post(`${this.apiUrl}${queryParams}`, null, options);
  }
  getDirections(apiKey: string, origin: string, destination: string): Observable<any> {
    const apiUrl = `https://maps.googleapis.com/maps/api/directions/json?origin=${origin}&destination=${destination}&key=${apiKey}`;

    return this.http.get(apiUrl);
  }
  getDirections1(apiKey: string, origin: string, destination: string): Observable<any> {
    const apiUrl = `https://maps.googleapis.com/maps/api/directions/json?origin=${origin}&destination=${destination}`;
    return this.http.get(apiUrl);
  }
  getDirections2(origin: string, destination: string): Observable<any> {
    const apiUrl = `https://maps.googleapis.com/maps/api/directions/json?origin=${origin}&destination=${destination}`;
    return this.http.get(apiUrl);
  }

  initMap(startLat: number, startLon: number, endLat: number, endLon: number): void {
    const origin = new google.maps.LatLng(startLat, startLon);
    const destination = new google.maps.LatLng(endLat, endLon);

    this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
      zoom: 10,
      center: origin
    });

    // Draw the route
    this.getDirections1('AIzaSyCyxa0d5VJiM4MCBrdLrSCa_CRA0TTYhpA', `${startLat},${startLon}`, `${endLat},${endLon}`)
      .subscribe(
        response => {
          const directionsRenderer = new google.maps.DirectionsRenderer();
          directionsRenderer.setMap(this.map as google.maps.Map);
          directionsRenderer.setDirections(response);
        },
        error => {
          console.error('Error getting directions:', error);
        }
      );
  }

}
